import { CATALOGO_CONQUISTAS } from '../core';
import { carregarPerfil, perfilAtual } from './conta';
import { sessaoDaConta } from './online';
import { somConquista, somNivel } from './som';
import { esc } from './util';

/**
 * Notificações de conta: um aviso na tela (e som) quando a conta sobe de nível ou libera uma conquista. O servidor concede as duas
 * coisas (ao apito final no online; ao selar o save no solo), então o navegador confere o perfil de tempos em tempos e compara
 * com o que já tinha visto. A primeira leitura de cada conta só marca o ponto de partida, sem avisar.
 */

let usuarioVisto: string | null = null;
let nivelVisto = 0;
let conquistasVistas = new Set<string>();

function contenedor(): HTMLElement {
  let el = document.getElementById('toasts');
  if (!el) {
    el = document.createElement('div');
    el.id = 'toasts';
    el.setAttribute('aria-live', 'polite');
    document.body.appendChild(el);
  }
  return el;
}

/** Mostra um aviso no canto da tela por alguns segundos (fora da área redesenhada pelo jogo, então não some num redesenho). */
export function avisoNaTela(icone: string, titulo: string, detalhe = ''): void {
  const t = document.createElement('div');
  t.className = 'toast';
  t.innerHTML = `<span class="toast-ico">${esc(icone)}</span><div><b>${esc(titulo)}</b>${detalhe ? `<span>${esc(detalhe)}</span>` : ''}</div>`;
  contenedor().appendChild(t);
  window.setTimeout(() => t.classList.add('saindo'), 6000);
  window.setTimeout(() => t.remove(), 6600);
}

const chaveConquista = (c: { id: string; temporada?: number }): string => `${c.id}:${c.temporada ?? ''}`;

/** Lê o perfil e avisa o que mudou desde a última leitura. */
export async function verificarNovidades(): Promise<void> {
  const s = sessaoDaConta();
  if (!s) {
    usuarioVisto = null;
    return;
  }
  await carregarPerfil();
  const p = perfilAtual();
  if (!p || p.usuario !== s.usuario) return;
  const nivel = p.nivel?.nivel ?? 0;
  const chaves = new Set(p.conquistas.map(chaveConquista));
  if (usuarioVisto !== p.usuario) {
    usuarioVisto = p.usuario;
    nivelVisto = nivel;
    conquistasVistas = chaves;
    return;
  }
  const catalogo = p.catalogo ?? [...CATALOGO_CONQUISTAS];
  const novas = p.conquistas.filter((c) => !conquistasVistas.has(chaveConquista(c)));
  let tocou = false;
  if (nivel > nivelVisto) {
    avisoNaTela('⭐', `Você subiu para o nível ${nivel}!`, p.nivel ? `${p.nivel.xp} XP · próximo nível com ${p.nivel.xpProximo} XP` : '');
    somNivel();
    tocou = true;
  }
  for (const c of novas) {
    const def = catalogo.find((d) => d.id === c.id);
    avisoNaTela(def?.icone ?? '🏆', `Conquista liberada: ${def?.titulo ?? c.id}`, def?.descricao ?? '');
    if (!tocou) {
      somConquista();
      tocou = true;
    }
  }
  nivelVisto = Math.max(nivelVisto, nivel);
  conquistasVistas = chaves;
}

/** Confere a conta logo ao abrir (ponto de partida) e a cada 12 s depois (a aba escondida não consulta). */
export function iniciarNotificacoes(): void {
  if (sessaoDaConta()) void verificarNovidades();
  window.setInterval(() => {
    if (document.hidden || !sessaoDaConta()) return;
    void verificarNovidades();
  }, 12_000);
}
